require("../scss/app.scss");

require("../fonts/SourceSansPro/face.css");

import sizes from "../scss/_settings/_settings.scss";
window.sizes = sizes;

const jq = require("jquery");
const $ = jq && jq.fn ? jq : jq && jq.$ && jq.$.fn ? jq.$ : jq;

import initValidation from "./common/js_validation.js";
initValidation($);

const initMain = require("./parts/main.js");
initMain($);

const editor = require("./parts/json-editor.js");
editor($);

const initPages = require("./pages.js");
initPages($);
